/*
 |--------------------------------------------------------------------------
 | Document Ready Function
 |--------------------------------------------------------------------------
 */
$(function () {
    'use strict';

    /*
     | Script to make tab work on the site.
     */

    // Add class 'active' for show tab content.
    $('a[data-toggle="tab"]').click((e) => {
        e.preventDefault();
        let tabTarget = $(e.currentTarget).attr('data-target'),
            tabItem = $(e.currentTarget).attr('href');

        $('a[data-toggle="tab"]').removeClass('active');
        $(e.currentTarget).toggleClass('active');

        $('[data-tab="' + tabTarget + '"]').each((i, t) => {
            $(t).removeClass('show');
        });

        $(tabItem).addClass('show');
    });
});
